function GraphismIcon() {
  return (
    <svg
      width="124"
      height="14"
      viewBox="0 0 124 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path id="Graphism" d="M124 1H74L62 13L50 1H0" stroke="url(#paint0_linear_3_578)" />
      <defs>
        <linearGradient
          id="paint0_linear_3_578"
          x1="98"
          y1="-5.5"
          x2="30.5"
          y2="18.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9299A3" />
          <stop offset="0.415" stopColor="white" />
          <stop offset="1" stopColor="#808696" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GraphismIcon
